export const Marquee = () => {
  const words = ["Breathe", "Move", "Pause", "Reconnect"];
  const seq = [...words, ...words, ...words, ...words];
  return (
    <section data-testid="marquee-section" className="py-10 md:py-16 overflow-hidden border-y border-[#8C8070]/15">
      <div className="flex whitespace-nowrap w-max animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
            {seq.map((w, i) => (
              <span key={`${dup}-${i}`} className="flex items-center">
                <span className="font-display italic font-light text-4xl md:text-6xl text-[#1A1A1A]/25 px-6 md:px-10">
                  {w}
                </span>
                <span className="h-2 w-2 rounded-full bg-[#F5C800]/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
